import Vue from 'vue'

Vue.filter('addLineBreaks', string => {
  return string.split(' ').join('<br>')
})
